import { render, staticRenderFns } from "./registerSectorStep2Page.vue?vue&type=template&id=697200a0&scoped=true&"
import script from "./registerSectorStep2Page.vue?vue&type=script&lang=js&"
export * from "./registerSectorStep2Page.vue?vue&type=script&lang=js&"
import style0 from "./registerSectorStep2Page.vue?vue&type=style&index=0&id=697200a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697200a0",
  null
  
)

export default component.exports